import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	defaultPriority: {
		id: 'admin-pages-priority-schemes.priority-schemes-table.priority-cell.default-priority',
		defaultMessage: 'Default',
		description: 'Default priority for a priority scheme associated with projects',
	},
});

export default messages;
